import { AsyncPipe } from '@angular/common';
import { Component, Output, EventEmitter, inject } from '@angular/core';
import { IAction, ActionType } from '@aston/foundation';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InactivityChannelService } from 'apps/middle/src/app/shared-module/services';

@Component({
	selector: 'inactivity-modal',
	templateUrl: './inactivity-modal.component.html',
	imports: [AsyncPipe, TranslateModule]
})
export class InactivityModalComponent {

	private inactivityService = inject(InactivityChannelService);
	public activeModal = inject(NgbActiveModal);

	@Output() actionResult = new EventEmitter<IAction>();

	isInactive$ = this.inactivityService.isInactive$;
	countdown$ = this.inactivityService.inactivityCountdown$;

	stayAlive() {
		this.activeModal.dismiss();
		this.actionResult.emit({ type: ActionType.UPDATE });
	}

	logout() {
		this.activeModal.dismiss();
		this.actionResult.emit({ type: ActionType.CLOSE });
	}
}
